// WWI tank traps — a cluster of three anti-tank obstacles on churned mud:
// one concrete "dragon's tooth" pyramid and two steel hedgehogs, each hedgehog
// three crossed angled beams meeting at the centre like a jack.
import * as THREE from "three";
import { defineModel, styleV3, type Part } from "../../lib";

const { box, cyl } = styleV3;

const CONCRETE = "#9a9891";
const GUNMETAL = "#4a4d52";
const MUD = "#5d4a33";

// A churned mud patch under each obstacle.
function mudPatch(x: number, z: number, r: number): Part {
  return cyl(r, r * 1.12, 0.035, 7, MUD, [x, 0.0175, z]);
}

// A steel hedgehog: three beams crossed at the centre, each tilted from the
// vertical and fanned 120 degrees apart, ends resting on the mud.
function hedgehog(x: number, z: number, phase: number): Part[] {
  const out: Part[] = [];
  const tilt = 1.08;             // lean from vertical (rad)
  const len = 0.42;
  const cy = 0.035 + (len / 2) * Math.cos(tilt); // beam ends touch the patch top
  for (let i = 0; i < 3; i++) {
    // Euler XYZ: the z-tilt is applied first, then the yaw about y.
    out.push(box(0.05, len, 0.05, GUNMETAL, [x, cy, z], [0, phase + (i * 2 * Math.PI) / 3, tilt]));
  }
  return out;
}

// A concrete dragon's tooth: a squat truncated pyramid.
function dragonsTooth(x: number, z: number): Part {
  return {
    geometry: new THREE.CylinderGeometry(0.055, 0.16, 0.3, 4),
    color: CONCRETE,
    position: [x, 0.035 + 0.15, z],
    rotation: [0, Math.PI / 5, 0],
  };
}

export const tankTrap = defineModel({
  id: "tank-trap",
  tiles: { w: 1, h: 1 },
  batchId: "wwi",
  name: "Tank Traps",
  tags: ["prop", "wwi", "military", "obstacle", "defense"],
  summary: "A cluster of anti-tank obstacles: a concrete dragon's tooth and two steel hedgehogs on churned mud.",
  author: "Fable 5",
  footprint: 0.42,
  parts(): Part[] {
    return [
      mudPatch(-0.22, -0.16, 0.18),
      mudPatch(0.24, -0.1, 0.17),
      mudPatch(-0.02, 0.24, 0.17),
      ...hedgehog(-0.22, -0.16, 0.3),
      dragonsTooth(0.24, -0.1),
      ...hedgehog(-0.02, 0.24, 1.4),
    ];
  },
  animations: [],
});
